
import config from 'config';
import HttpClient from 'utils/httpclient';
import { LOADING, LOADED } from 'stores/BaseStore';
import appStore from 'stores/app';
import postStore from 'modules/cms/stores/post'
import pageStore from 'modules/path/stores/page'
import { buildEntity } from './base-store';

import allocationStore from '@Modules/offer/stores/allocation';
import publisherStore from '@Modules/offer/stores/publisher'
import pathStore from '@Modules/path/stores/path'
import pathUserProfileStore from '@Modules/path/stores/user_profile'
import integrationStore from '@Modules/settings/stores/integration'

export default new class CCPAStore {
  data = {};
  status = LOADED;
  posts = null
  offers = null
  paths = null
  pages = null
  deleteConsumer = {
    status: LOADED,
    get isLoading() {
      return this.status === LOADING
    }
  }
  supressConsumer = {
    status: LOADED,
    get isLoading() {
      return this.status === LOADING
    }
  }

  allocation = buildEntity(allocationStore, {
    labelKey: 'description',
  })

  integration = buildEntity(integrationStore, {
    labelKey: 'description',
  })

  publisher = buildEntity(publisherStore, {})
  path = buildEntity(pathStore, {})
  page = buildEntity(pageStore, {})
  pathUserProfile = buildEntity(pathUserProfileStore, {})

  async getInquiry(params) {
    try {
      this.status = LOADING
      params.organizationId = appStore.site.organizationId
      const { data } = await HttpClient.get(`${config.api}/reports/inquiry`, { params })
      this.posts = await postStore.list({}).then(({ data: { rows } }) => rows)
      this.pages = await pageStore.list({}).then(({ data: { rows } }) => rows)
      this.data = data
      this.status = LOADED
      return Object.entries(data)
    } catch (e) {
      this.status = LOADED
    }
  }

  async supressConsumerData(params) {
    try {
      this.supressConsumer.status = LOADING
      params.siteId = appStore.site.id
      const { data } = await HttpClient.post(`${config.api}/ccpa/suppress`, params)
      this.supressConsumer.status = LOADED
      return data
    } catch (e) {
      this.supressConsumer.status = LOADED
    }
  }

  async deleteConsumerData(params) {
    try {
      this.deleteConsumer.status = LOADING
      params.organizationId = appStore.site.organizationId
      const { data } = await HttpClient.delete(`${config.api}/ccpa/delete`, { data: params })
      this.deleteConsumer.status = LOADED
      return data
    } catch (e) {
      this.deleteConsumer.status = LOADED
    }
  }

  getSiteName(stid) {
    return (appStore.sites && appStore.sites.find(({ id }) => id == stid) || {}).name
  }

  getPage(pageId) {
    return (this.pages && this.pages.find(({ id }) => id == pageId)) || {}
  }

  get isLoading() {
    return this.status === LOADING
  }
}
